import {
  CreateWebFunctionRequest,
  LambdaWebEndpointConfig,
  LambdaWebRevisionConfig,
  LambdaWebBuildConfig,
  LambdaWebServiceConfig,
} from './lambdaweb';

// API-shaped draft: code and role may be supplied by provisioning after submit.
// Numeric text controls return strings until the Resource Browser converts them.
export type LambdaWebFunctionCreateRequest = Omit<
  CreateWebFunctionRequest,
  'functionName' | 'revisionConfig' | 'endpointConfig'
> & {
  functionName: string;
  revisionConfig: Omit<LambdaWebRevisionConfig, 'buildConfig' | 'serviceConfig'> & {
    buildConfig: Omit<LambdaWebBuildConfig, 'codeConfig' | 'runtimeConfig'> & {
      runtimeConfig: { runtime: string };
      codeConfig?: LambdaWebBuildConfig['codeConfig'];
    };
    serviceConfig?: Omit<LambdaWebServiceConfig, 'executionRoleArn' | 'maxConcurrencyPerEnvironment'> & {
      executionRoleArn?: string;
      maxConcurrencyPerEnvironment?: number | string;
    };
  };
  endpointConfig: LambdaWebEndpointConfig;
};

// UI-only choices, kept outside the API schema and request payload.
export interface LambdaWebFunctionCreateOptions {
  codeSource: 'template' | 'upload' | 's3';
  zipFile?: File;
  storageBucket?: string;
  useExistingRole?: boolean;
  useKmsKey?: boolean;
  configureConcurrency?: boolean;
}

export interface LambdaWebRevisionFormValues {
  codeSource: 'upload' | 's3';
  zipFile?: File;
  sourceBucket?: string;
  sourceKey?: string;
  sourceVersion?: string;
  description?: string;
}
